const getScrollInfo = (scrollContainer) => {
  let hasScrollBehavior = false;

  if (
    scrollContainer &&
    scrollContainer.style &&
    "scrollBehavior" in scrollContainer.style
  ) {
    hasScrollBehavior = true;
  }

  const disableScrollAnimation = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  return {
    disableScrollAnimation,
    hasScrollBehavior,
  };
};

export { getScrollInfo };
